module.exports = __webpack_public_path__ + "img/certNew.97e69e91.png";